import { observable, makeObservable } from 'mobx';
import { AppService } from './AppService';
import PolicyPreviewService from './PolicyPreviewService';
import { PolicyScheduleAService } from './PolicyScheduleAService';
import { PolicyScheduleBService } from './PolicyScheduleBService';
import OrderDetailsService from './OrderDetailsService';

export interface IRootStore {
  appData: AppService;
}

export class RootStore {
  public appData: AppService;

  public orderDetailsService: OrderDetailsService;

  public policyScheduleBService: PolicyScheduleBService;

  public policyScheduleAService: PolicyScheduleAService;

  public policyPreviewService: PolicyPreviewService;

  constructor() {
    makeObservable(this, {
      appData: observable,
      orderDetailsService: observable,
      policyScheduleBService: observable,
      policyScheduleAService: observable,
      policyPreviewService: observable,
    });

    this.appData = new AppService();
    this.orderDetailsService = new OrderDetailsService();
    this.policyScheduleAService = new PolicyScheduleAService(this);
    this.policyScheduleBService = new PolicyScheduleBService(this);
    this.policyPreviewService = new PolicyPreviewService(this);
  }
}
